module.exports = __webpack_public_path__ + "img/settings.02d0e80e.jpg";